<template>
	<div class="layer-project" data-project-name="db-life-smart-phone-sales">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						<span class="nowrap">DB Life Smart <br />Phone</span>
						<span class="nowrap">Sales <br />Support System</span>
					</h1>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						모바일 APP을 Web 방식으로 전환하여 영업지원 시스템의 사용성 확대 및
						강화에 중점을 두고 개발하였습니다.
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram01">
							<li class="item01">
								Supplementing<br />The Authentication<br />Method
							</li>
							<li class="item02">Improved<br />UI/UX Design</li>
							<li class="item03">User<br />Convenience</li>
						</ul>
						<p class="diagram02">DB생명<br />스마트폰 영업지원<br />시스템</p>
					</div>
				</div>
			</section>
			<!-- Details [e] -->
			<!-- section01 : mobile-web [s] -->
			<section class="section full section01">
				<div class="inner-section">
					<div class="information-area">
						<strong class="project-subtit">Mobile</strong>
						<p class="sub-text">
							사용자 중심의 차별화되고 트렌디한 UI/UX를 적용하여 디자인을
							개편하였습니다.<br />
							다양한 인증 수단을 보완하여 사용자의 접근성을 향상시키고,
							계약/심사 관련 조회 서비스를 제공하여 사용자 편의성을
							강화하였습니다.
						</p>
					</div>
					<div class="img-box">
						<div class="img img01">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/db-life-smart-phone-sales/mobile-web-01-img@m.png"
							/>
						</div>
						<div class="img img02">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/db-life-smart-phone-sales/mobile-web-02-img@m.png"
							/>
						</div>
					</div>
					<div class="mobile-swiper-area">
						<div class="mobile-swiper">
							<ul class="swiper-wrapper">
								<li class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/db-life-smart-phone-sales/mobile-web-swiper01.png"
									/>
								</li>
								<li class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/db-life-smart-phone-sales/mobile-web-swiper02.png"
									/>
								</li>
								<li class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/db-life-smart-phone-sales/mobile-web-swiper03.png"
									/>
								</li>
							</ul>
							<!-- Add Pagination -->
							<div class="swiper-pagination" data-bgcolor="green"></div>
						</div>
					</div>
				</div>
			</section>
			<!-- section01 : mobile-web [e] -->
			<!-- section02 : mobile-web-img [s] -->
			<section class="section full section02">
				<div class="inner-section">
					<div class="img-box">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/db-life-smart-phone-sales/mobile-01-img@m.png"
						/>
					</div>
					<div class="img-box">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/db-life-smart-phone-sales/mobile-02-img@m.png"
						/>
					</div>
				</div>
			</section>
			<!-- section02 : mobile-web-img [e] -->
			<!-- section03 : device [s] -->
			<section class="section section03">
				<div class="inner-section">
					<div class="information-area">
						<strong class="project-subtit">User Flow</strong>
					</div>
					<div class="img-box">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/db-life-smart-phone-sales/userflow@m.png"
						/>
					</div>
				</div>
			</section>
			<!-- section03 : device [e] -->
			<!-- section04 : project identity [s] -->
			<section class="section section04">
				<div class="inner-section">
					<div class="information-area">
						<strong class="project-subtit"
							>Color &amp; Fonts<br />
							Guide</strong
						>
					</div>
					<div class="point-area">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/db-life-smart-phone-sales/point-color-and-font@m.png"
						/>
					</div>
				</div>
			</section>
			<!-- section04 : project identity [e] -->
			<section class="project-client">
				<strong class="a11y-hidden"
					>DB Life Smart Phone Sales Support System</strong
				>
			</section>
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		//onload

		this.projectInit();

		var isPcWebMain = false;
		var pcWebMainSwiper;

		pcWebMainSet();

		$(window).on("resize", function () {
			resizeSet();
		});

		function resizeSet() {
			var w = $(window).outerWidth();
			if (w >= 712 && isPcWebMain) {
				pcWebMainSwiper.destroy();
				isPcWebMain = false;
			} else {
				pcWebMainSet();
			}
		}

		function pcWebMainSet() {
			var w = $(window).outerWidth();

			if (isPcWebMain | (w >= 712)) {
				return;
			}
			isPcWebMain = true;
			pcWebMainSwiper = new Swiper(".mobile-swiper", {
				slidesPerView: "auto",
				spaceBetween: 12,
				centeredSlides: true,
				pagination: {
					el: ".mobile-swiper .swiper-pagination",
					clickable: true,
				},
			});
		}
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */

/* Common */
.sub-text {
	word-break: keep-all;
}
/*   */
.project-subtit {
	display: block;
	margin-bottom: 10px;
	font-size: 3.3rem;
}
.sub-text {
	line-height: 1.5;
	font-weight: 500;
}
.information-area {
	padding: 0 15px;
}
.layer-project-detail {
	overflow: hidden;
	background-color: transparent;
}
@media screen and (min-width: 712px) {
	.project-subtit {
		font-size: 3.3rem;
	}
	.information-area {
		padding: 0 40px;
	}
}
@media screen and (min-width: 1280px) {
	.project-subtit {
		font-size: 56px;
	}
	.sub-text {
		font-size: 15px;
		line-height: 28px;
		font-weight: 400;
	}
	.information-area {
		padding: 0;
	}
	.inner-section {
		max-width: 1280px;
		margin: 0 auto;
		padding: 0;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/db-life-smart-phone-sales/ci.png)
		50% / auto 43px no-repeat;
	background-color: #e4f4f2;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/db-life-smart-phone-sales/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/db-life-smart-phone-sales/bg-overview@t.jpg);
	}
	.project-visual br {
		display: none;
	}
	.project-visual .nowrap {
		display: block;
	}
	.project-client {
		background-size: auto 62px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/db-life-smart-phone-sales/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 90px;
	}
}
/* Overview */
.project-overview {
	background-color: #00a487;
	color: #fff;
}
.project-overview-txt {
	margin-bottom: 30px;
	font-weight: 400;
	line-height: 1.5;
}
.project-overview-diagram {
	font-weight: 500;
	line-height: 1.7rem;
}
.project-overview-diagram .diagram01 {
	position: relative;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	margin-bottom: 10px;
	padding-top: 12.5px;
	padding-bottom: 65px;
}
.project-overview-diagram .diagram01:after {
	content: "";
	position: absolute;
	bottom: 0px;
	left: 50%;
	width: 1px;
	height: 40px;
	background-color: #fff;
}
.project-overview-diagram li {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 140px;
	height: 140px;
	margin: -12.5px -3.5px;
	padding: 4px;
	border-radius: 50%;
	border: 1px solid #fff;
	text-align: center;
}
.project-overview-diagram .diagram02 {
	display: flex;
	flex-wrap: wrap;
	flex-flow: column;
	justify-content: center;
	align-items: center;
	width: 140px;
	height: 140px;
	margin: 0 auto;
	padding: 10px;
	border-radius: 50%;
	text-align: center;
	background-color: #fff;
	color: #00854a;
}
.project-overview-diagram .diagram02 span {
	font-size: 1.6rem;
}
@media screen and (max-width: 711px) {
	.project-overview-txt span {
		display: block;
	}
}
@media screen and (min-width: 712px) {
	.project-overview {
		padding-bottom: 35px;
	}
	.project-overview-diagram {
		display: flex;
		justify-content: center;
	}
	.project-overview-diagram .diagram01 {
		margin-bottom: 0;
		padding-top: 0;
		padding-bottom: 0;
		padding-right: 100px;
	}
	.project-overview-diagram .diagram01:after {
		bottom: 50%;
		left: auto;
		right: 0;
		width: 89px;
		height: 1px;
	}
	.project-overview-diagram li {
		margin: 0;
	}
	.project-overview-diagram li + li {
		margin-left: -8px;
	}
	.project-overview-diagram .diagram02 {
		margin-left: 15px;
		margin-right: 0;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview {
		padding: 51px 0 75px;
	}
	.project-overview .inner-section {
		padding: 0;
	}
	.project-overview-tit {
		margin-bottom: 12px;
	}
	.project-overview-txt {
		margin-bottom: 73px;
	}
	.project-overview-txt span {
		display: block;
	}
	.project-overview-diagram li,
	.project-overview-diagram .diagram02 {
		width: 230px;
		height: 230px;
		font-size: 20px;
	}
	.project-overview-diagram li {
		border-width: 2px;
		padding: 20px;
		line-height: 1.5;
	}
	.project-overview-diagram li + li {
		margin-left: -14px;
	}
	.project-overview-diagram .diagram01 {
		padding-right: 208px;
	}
	.project-overview-diagram .diagram01:after {
		bottom: calc(50% - 1px);
		left: auto;
		right: 0;
		width: 178px;
		height: 2px;
	}
	.project-overview-diagram .diagram02 {
		margin-left: 30px;
		line-height: 1.2;
	}
	.project-overview-diagram .diagram02 span {
		font-size: 28px;
	}
}
.section01 {
	background-color: #fff;
	background: url(/static/img/project-detail/db-life-smart-phone-sales/bg-mobile-web-01-img@m.png)
		no-repeat 0 100vw;
	background-size: 100%;
}
.section01 .img-box {
	display: flex;
	padding: 50px 0 50px 15px;
	justify-content: space-between;
}
.section01 .mobile-swiper-area {
	position: relative;
	text-align: center;
}
.section01 .swiper-slide {
	width: 55vw;
}
.section01 .swiper-container-horizontal > .swiper-pagination-bullets {
	bottom: -15px;
}
.section01 .swiper-pagination-bullet {
	width: 13px;
	height: 13px;
	border: 2px solid #014343;
	opacity: 1;
	background-color: transparent;
}
.section01 .swiper-pagination-bullet-active {
	background-color: #014343;
}
@media screen and (max-width: 711px) {
	.section01.full {
		padding-bottom: 40px;
	}
	.section01 .img-box .img01 {
		width: 39.06vw;
	}
	.section01 .img-box .img02 {
		width: 55.31vw;
		text-align: right;
	}
}
@media screen and (min-width: 712px) {
	.section01 {
		background-color: #fff;
		background: url(/static/img/project-detail/db-life-smart-phone-sales/bg-mobile-web-01-img@t.png)
			no-repeat 0 20vw;
		background-size: 100%;
	}
	.layer-project-detail > section.section01 {
		padding: 0;
	}
	.section01 .inner-section {
		padding-top: 40px;
	}
	.section01 .img-box {
		padding: 12.64vw 40px 0;
		position: relative;
	}
	.section01 .img-box .img01 {
		width: 48.17vw;
	}
	.section01 .img-box .img02 {
		position: absolute;
		right: 0;
		top: -4.21vw;
		width: 41.71vw;
	}
	.section01 .information-area {
		padding: 0 40px;
		width: 65%;
	}
	.section01 .information-area br {
		display: none;
	}
	.section01 .img {
		width: 100%;
		text-align: center;
	}
	.section01 .mobile-swiper-area {
		position: relative;
		text-align: center;
		padding: 8.27vw 3.79vw 10.27vw;
	}
	.section01 .swiper-wrapper {
		justify-content: space-between;
	}
	.section01 .swiper-slide {
		width: 24.71vw;
	}
	.mobile-swiper .swiper-pagination {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	.section01 {
		background-color: #fff;
		background: url(/static/img/project-detail/db-life-smart-phone-sales/bg-mobile-web-01-img@w.png)
			no-repeat 0 450px;
		background-size: 100%;
	}
	.section01 .inner-section {
		position: relative;
		display: block;
		max-width: 1280px;
		padding-top: 89px;
	}
	.section01 .inner-section:after {
		content: "";
		display: block;
		clear: both;
	}
	.section01 .information-area {
		padding: 0 15px;
		width: 100%;
	}
	.section01 .information-area br {
		display: block;
	}
	.section01 .project-subtit {
		margin-bottom: 3px;
	}
	.section01 .img {
		width: 1026px;
	}
	.section01 .img-box {
		padding: 0;
		position: relative;
		width: 1280px;
	}
	.section01 .img-box .img01 {
		margin-top: 145px;
		width: 696px;
	}
	.section01 .img-box .img02 {
		position: absolute;
		right: -63px;
		width: 596px;
	}
	.section01 .swiper-slide {
		width: 352px;
	}
	.section01 .mobile-swiper-area {
		padding: 170px 0 200px;
	}
	.section01 .swiper-slide + .swiper-slide {
		margin-left: 148px;
	}
}
.layer-project-detail > .section02.full {
	padding: 0;
}
.section02 {
	position: relative;
}
.section02 .project-subtit {
	margin-bottom: 0;
	text-align: center;
}
.section02 .layout-swiper-area {
	background-color: #b4a284;
}
.section02 .swiper-wrapper {
	top: -22vw;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
	bottom: 40px;
}
.swiper-pagination-bullet {
	width: 13px;
	height: 13px;
	border: 2px solid #fff;
	opacity: 1;
	background-color: transparent;
}
.swiper-pagination-bullet-active {
	background-color: #fff;
}
.section02 img {
	width: 100%;
}
@media screen and (min-width: 712px) {
	.section02 .swiper-wrapper li {
		width: 50%;
	}
	.section02 .layout-swiper-area {
		height: 450px;
	}
}
@media screen and (min-width: 1280px) {
	.section02 .inner-section {
		max-width: 100%;
	}
	.section02 .img img {
		width: auto;
	}
}
.section03 {
	position: relative;
	background: url(/static/img/project-detail/db-life-smart-phone-sales/bg-userflow@m.png)
		no-repeat 100% 0;
	padding: 0 0 40px;
}
.section03 .img-box {
	padding: 0 10px;
}
.section03 img {
	width: 100%;
}
@media screen and (max-width: 711px) {
	.section03 .inner-section {
		margin-top: -100px;
	}
	.section03 .project-subtit {
		margin-bottom: 20px;
		padding: 0;
	}
}
@media screen and (min-width: 712px) {
	.section03 {
		position: relative;
		background: url(/static/img/project-detail/db-life-smart-phone-sales/bg-userflow@t.png)
			no-repeat 100% 100%;
		background-size: 150px;
	}
	.layer-project-detail > section.section03 {
		padding-bottom: 0;
		padding-top: 0;
	}
	.section03 .inner-section {
		margin-top: -7.73vw;
	}
	.section03 .project-subtit {
		margin-bottom: 3.15vw;
		padding: 0;
	}
	.section03 .inner-section {
		position: relative;
		background-size: 29vw;
		background-position: center 8vw;
	}
	.section03 .swiper-slide {
		width: 25vw;
		padding: 20px;
	}
	.section03 .img-box {
		padding: 0 40px;
	}
}
@media screen and (min-width: 1280px) {
	.section03 {
		position: relative;
		padding: 0;
		background: none;
	}
	.section03::after {
		content: "";
		position: absolute;
		right: -100px;
		bottom: -100px;
		z-index: -1;
		width: 590px;
		height: 1139px;
		background: url(/static/img/project-detail/db-life-smart-phone-sales/bg-userflow@w.png)
			no-repeat;
	}
	.section03 .inner-section {
		max-width: 1440px;
		padding: 0 80px;
		margin-top: -140px;
	}
	.section03 .project-subtit {
		margin-bottom: 79px;
	}
	.section03 .information-area {
		top: 95px;
		left: 100px;
		width: 310px;
		padding: 0;
	}
	.section03 .img-box {
		padding: 0;
	}
}
.section04 {
	position: relative;
}
.section04 .information-area {
	padding: 0;
}
.section04:before {
	content: "";
	position: absolute;
	left: 0;
	z-index: -1;
	width: 100%;
	height: 100%;
	background: url(/static/img/project-detail/db-life-smart-phone-sales/bg-point-color-and-font@m.png)
		no-repeat;
}
@media screen and (max-width: 711px) {
	.section04 {
		padding-top: 0;
	}
	.section04:before {
		background-size: 18.26vw;
		top: -20.31vw;
	}
	.section04 .project-subtit br {
		display: block;
	}
}
@media screen and (min-width: 712px) {
	.section04 {
		padding-top: 0;
	}
	.section04 .inner-section {
		padding-top: 50px;
		padding-bottom: 20px;
	}
	.section04 .information-area {
		padding: 0;
	}
	.section04 .project-subtit br {
		display: none;
	}
	.point-area {
		display: flex;
		justify-content: space-between;
	}
	.color-area-wrap .color li {
		width: 55px;
		text-align: center;
	}
}
@media screen and (min-width: 1280px) {
	.section04:before {
		left: 0;
		background: url(/static/img/project-detail/db-life-smart-phone-sales/bg-point-color-and-font@w.png)
			no-repeat;
		background-size: 200px;
	}
	.section04 .inner-section {
		padding: 153px 0 110px;
	}
	.section04 .information-area {
		padding: 0;
	}
	.point-area {
		margin-top: 62px;
	}
	.section04 .project-subtit br {
		display: none;
	}
}
</style>


// WEBPACK FOOTER //
// src/projects/db-life-smart-phone-sales.vue